<template>

	<div id="app" v-if="isFull">

		<nav-header />

		<router-view></router-view>
		
		<founder-thoughts v-if="founderThoughts && isNotTextual" />

		<contact-section v-if="isNotTextual"/>

		<nav-footer @displaySiteMap="$refs.siteMapModal.display()" :hide-logo-belt="!isNotTextual"/>

		<siteMapModal ref="siteMapModal" />

	</div>

</template>

<script>
/* eslint-disable */
import navHeader from './components/nav-header.vue';
import navFooter from './components/nav-footer.vue';
import founderThoughts from './views/FounderThoghts.vue';
import contactSection from './components/contact-section.vue';
import siteMapModal from './components/site-map-modal.vue';

import { mapActions } from 'vuex';
import ContactSection from './components/contact-section.vue';

export default {
	name: 'App',
	props: {
		founderThoughts: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		isNotTextual() {
			const textualRoutes = ['Page'];
			return !textualRoutes.includes(this.$route.name);
		}
	},
	components: {
		navHeader,
		navFooter,
		founderThoughts,
		contactSection,
		siteMapModal
	},
	data: () => {
		return {
			sample: false,
			isFull: true
		};
	},
	mounted() {
		// document.addEventListener('DOMContentLoaded', () => {
		if (window.mainUI && typeof window.mainUI === 'function') {
			window.mainUI();
		}
		// });
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.adjustViewMargin);
	},
	watch: {
		$route(to, from) {
			if (this.isFull && to.name && to.name !== from.name) {
				this.$nextTick(() => {
					this.scrollTo();
				});
			}
		},
	},
	methods: {
		...mapActions(['catalogUpdate']),
		scrollTo() {
			// if(to.name && to.name !== from.name){
			window.scrollTo({
				top: 0,
				// behavior: 'smooth'
			});
			// }
		},
		adjustViewMargin() {
			const footer = document.getElementById('nav-footer');
			const view = document.getElementById('view');
			if (footer && view) {
				view.style.marginBottom = `${footer.offsetHeight - 80 / 2}px`;
			}
			setTimeout(() => {
				this.adjustHeaderMargin();
			}, 400);
			// this.adjustHeaderMargin();
		},
		adjustHeaderMargin() {
			const header = document.getElementById('nav-header');
			const view = document.getElementById('view');
			if (header && view) {
				view.style.marginTop = `${header.offsetHeight}px`;
			}
		},
		loadScript(scriptURI) {
			// This is necessary to force Vue to insert the cordova.js plugin.
			var script = document.createElement("script");
			script.setAttribute("src", scriptURI);
			script.setAttribute("type", "text/javascript");
			document.getElementsByTagName("head")[0].appendChild(script);
		}
	},
	async beforeMount() {
		this.isFull = false;
		try {
			await this.catalogUpdate();
			document.addEventListener('DOMContentLoaded', () => {
				// await this.recoverFromDixie();
				this.isFull = true;
			});
		} catch (error) {
			console.error('Error updating catalog:', error);
		} finally {
			this.isFull = true;
		}
	}
}
</script>

<style lang="scss">
#app {
	.section {
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1em;
		background: white;
		min-height: 10em;

		button {
			padding: 1em 2em;
			font-size: 1.2rem;
			border-radius: var(--ui-radius);
			background-color: var(--primary);
			color: var(--white);
			border: none;
			cursor: pointer;
		}
	}

	pre {
		color: black;
		background-color: #f5f5f5;
		padding: 10px;
		border-radius: 4px;
		overflow-x: auto;
	}

	.no-break {
		white-space: nowrap;
	}

	.pre-line {
		white-space: pre-line;
	}

	.mermaidLoader {
		display: flex;
		flex-flow: column;
		align-content: center;
		align-items: center;
		background: white;
		svg {
			max-width: inherit !important;
		}
	}

	.lower-case,
	.lowercase {
		text-transform: lowercase;
	}

	.upper-case,
	.uppercase {
		text-transform: uppercase;
	}

	.title-like,
	.titlelike {
		text-transform: capitalize;
	}

}
</style>